import { useRowPagination } from "hooks/useRowPagination";

import ClaimCard from "./PolicyCards/ClaimCard";
import RowPagination from "components/General/RowPagination";
import { useTranslation } from "react-i18next";

const ServiceAndClaimsTab = ({ claims }) => {
  const {
    rowsForDisplay: claimRows,
    rowPaginationProps: claimsPaginationProps,
  } = useRowPagination(claims, [3, 10, 25, "all"]);
  const { t } = useTranslation();
  return (
    <>
      <div className="ui-component-spacing">
        <h3 className="font-brand text-lg md:text-2xl">
          {t("AgentServiceAndClaimsTab-claims")}
        </h3>
        <hr className="ui-under-title" />
        {claimRows?.length > 0 ? (
          <>
            {claimRows.map((policy, index) => {
              return (
                <ClaimCard
                  data={policy}
                  cardExpanded={index === 0 ? true : false}
                  key={`claims - ${index}`}
                />
              );
            })}
            <RowPagination {...claimsPaginationProps} />
          </>
        ) : (
          <div className="border border-dashed border-ui-gray p-6 my-6">
            <div className="text-center">
              <div className="text-xl font-bold">
                {t("AgentServiceAndClaimsTab-claim-dsc-1")}
              </div>
              <div className="mt-1 text-theme-text-quaternary text-sm">
                {t("AgentServiceAndClaimsTab-claim-dsc-2")}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ServiceAndClaimsTab;
